import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=2a6160ee&scoped=true&"
import script from "./NoticeForm.vue?vue&type=script&lang=js&"
export * from "./NoticeForm.vue?vue&type=script&lang=js&"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=2a6160ee&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6160ee",
  null
  
)

export default component.exports